import { IconButton } from "@mui/material";
import TopNav from "../components/TopNav";
import splitStyle from "./SplitPage.module.css";
import { ReactNode, useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "@mui/icons-material";

function SplitPageView({
  contentList,
  mainContent,
  pageTitle,
  breadcrumbs,
}: {
  contentList: ReactNode;
  mainContent: ReactNode;
  breadcrumbs?: ReactNode;
  pageTitle: string;
}) {
  const [openSidebar, setOpenSidebar] = useState(
    !!(sessionStorage.getItem("openSidebar") === null
      ? true
      : JSON.parse(sessionStorage.getItem("openSidebar")!))
  );
  console.log(openSidebar);
  const toggleSidebar = (b: boolean) => {
    setOpenSidebar(b);
    sessionStorage.setItem("openSidebar", JSON.stringify(b));
  };

  return (
    <div className={`page ${splitStyle.page}`}>
      <TopNav pageTitle={pageTitle} />
      <main className={splitStyle.split}>
        {openSidebar ? (
          <div className={splitStyle.sidebar}>
            <div>
              <IconButton onClick={() => toggleSidebar(false)}>
                <ArrowLeft />
              </IconButton>
            </div>
            <div className={splitStyle.scrollContainer}>{contentList}</div>
          </div>
        ) : (
          <div>
            <IconButton onClick={() => toggleSidebar(true)}>
              <ArrowRight />
            </IconButton>
          </div>
        )}
        <div className={splitStyle.viewerContainer}>
          <div className={splitStyle.breadcrumbs}>{breadcrumbs}</div>
          <div className={splitStyle.viewer}>{mainContent}</div>
        </div>
      </main>
    </div>
  );
}

export default SplitPageView;
